import { Component } from 'vue-property-decorator';
import {
  DecksAndCabinsBlockViewModel,
  DeckViewItem,
  DeckCategoryView,
} from './DecksAndCabinsModule.types';
import { getComponentProps } from '@/utils/vueUtils';
import { mixins } from 'vue-class-component';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import {
  DecksAndCabinsModuleState,
  SET_CURRENT_DECK,
  SET_CURRENT_DECK_CATEGORY,
  GET_SVG_REQUEST,
  SET_CURRENT_CABIN_CODE,
  SET_OPEN_DATES_AND_RATES,
  SET_ITINERARY_URL,
  SvgApiData,
} from './DecksAndCabinsModule.store';
import { format } from 'date-fns';

import SvgImage from './SvgImage/SvgImage.vue';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import ShipIcon from '@/assets/icons/ship.svg?inline';
import Chevron from '@/assets/icons/chevron.svg?inline';
import CtaItem from '@/components/CtaItem/CtaItem.vue';
import { Affix } from 'vue-affix';
import InputCheck from '@/components/InputCheck/InputCheck.vue';

import DeckView from './DeckView/DeckView.vue';
import CabinCategoryContainer from './CabinCategoryContainer/CabinCategoryContainer.vue';
import { isDesktopSafari, toggleModalClassListWithoutTouchMove } from '@/utils/commonUtils';
import ButtonClose from '@/components/ButtonClose/ButtonClose.vue';
import { DeckItem, CategoryItem } from '@/common/interfaces/modules/DatesAndRates';

@Component({
  props: getComponentProps<DecksAndCabinsBlockViewModel>({
    ShipItinerariesLink: '',
    ShipName: '',
    ShipId: 1,
    ShipGuests: 1,
    Itinerary: '',
    Items: [],
    CurrentDate: new Date(2020, 5, 1),
    Decks: [
      {
        Name: 'Bridge Deck',
        Image: {
          Url: '/images/bridge-deck.svg',
          Alt: 'Bridge deck',
        },
        CtaItems: [],
        Categories: [
          {
            Id: 1,
            Code: '05',
            Color: '#9ED2F1',
            Title: 'Deluxe suite with window 3',
            Images: [
              { Url: '/images/bed.jpg', Alt: 'Bed' },
              { Url: '/images/bed.jpg', Alt: 'ed' },
              { Url: '/images/bed.jpg', Alt: 'ed' },
              { Url: '/images/bed.jpg', Alt: 'ed' },
              { Url: '/images/bed.jpg', Alt: 'ed' },
            ],
            Text:
              '<p class="text--small">710 Cabins feature two lower single beds and at least one large window. Feature one queen-size bed. All cabins feature climate controls, a TV showing the ship\'s position and programing. Bathrooms are also generously sized with a roomy glass-walled shower stall. The dining room is on this deck and accommodates all guests at once.</p><br><p>*Prices are per person, double occupancy</p>',
            Single: {
              Price: '$16,290',
            },
            Double: {
              Price: '',
            },
            Triple: {
              Price: '$16,290',
            },
          },
        ],
      },
    ],
    Categories: [
      {
        Id: 0,
        Code: '01',
        Color: '#FFDC99',
        Title: 'Deluxe suite with window',
        Text: 'Lorem ipsum dolor sit amet consectetur adipiscing elit',
        Images: [
          { Url: '/images/kayak.jpg', Alt: 'Kayak' },
          { Url: '/images/kayak.jpg', Alt: 'Kayak' },
        ],
        Single: {
          Price: '$16,290',
          IsFewLeft: false,
        },
        Double: {
          Price: '$16,290',
          IsFewLeft: false,
        },
      },
    ],
    MonthsOfDepartures: [],
  }),
  components: {
    DeckView,
    CabinCategoryContainer,
    SvgImage,
    SvgIcon,
    ShipIcon,
    Chevron,
    CtaItem,
    Affix,
    InputCheck,
    ButtonClose,
  },
})
export default class DecksAndCabinsModule extends mixins(StoreModuleMixin) {
  state!: DecksAndCabinsModuleState;

  getSvgData: (data: SvgApiData) => void = this.getAction(GET_SVG_REQUEST);
  setCurrentDeck: (deck: DeckItem | null) => void = this.getMutation(SET_CURRENT_DECK);
  setCurrentDeckCategory: (deck: CategoryItem | null) => void = this.getMutation(
    SET_CURRENT_DECK_CATEGORY,
  );
  setCurrentCabinCode: (code: string) => void = this.getMutation(SET_CURRENT_CABIN_CODE);
  setActiveDatesAndRates: (boolean) => void = this.getMutation(SET_OPEN_DATES_AND_RATES);
  setUrl: (string) => void = this.getMutation(SET_ITINERARY_URL);
  p: any;
  currentDeckScrollPosition: number = 0;
  isDeckOpened: boolean = false;

  get currentDeck(): DeckViewItem | null {
    return this.state.CurrentDeck;
  }

  get decks() {
    return this.state.Decks;
  }

  get currentDate() {
    return this.state.CurrentDate;
  }

  get currentCabinCode() {
    return this.state.CurrentCabinCode;
  }

  get currentDeckCategory(): DeckCategoryView | null {
    return this.state.CurrentDeckCategory;
  }

  get showDateSelector() {
    const date = new Date(this.state.CurrentDate);
    return format(date, 'dd MMM Y');
  }

  get scrollOffsetPos() {
    return {
      top: 90,
      bottom: 40,
    };
  }

  get url() {
    let segment = window.location.pathname.split('decks-cabins')[1],
      segmentFound = segment;
    if (!segment) return null;
    if (segment.length < 2) return null;
    if (segmentFound) {
      let someUrl =
        window.location.pathname.split('decks-cabins')[0] +
        'decks-cabins/' +
        segmentFound.split('/')[1];
      this.setUrl(someUrl.replace(/\/$/, ''));
      return someUrl.replace(/\/$/, '');
    }
  }

  get isSafari() {
    return isDesktopSafari();
  }

  openDeckView(deck: DeckItem) {
    this.isDeckOpened = true;
    this.currentDeckScrollPosition = window.scrollY;
    this.setCurrentDeck(deck);
    this.resetDeckCategory(deck);
    toggleModalClassListWithoutTouchMove();

    // Hide footer when the deck popup is open, as footer can overlap deck on macOS
    if (isDesktopSafari()) document.querySelector('.footer.module').classList.add('lex-d-none', 'safari-footer-fix');
  }

  isActiveDeck(deck: DeckItem) {
    return this.currentDeck && this.currentDeck.Deck && deck.Name === this.currentDeck.Deck.Name;
  }

  closeDeckView() {
    this.isDeckOpened = false;
    toggleModalClassListWithoutTouchMove();

    //Resets current Deck
    this.setCurrentDeck(null);
    this.resetDeckCategory(null);

    if (isDesktopSafari()) {
      document.querySelector('.footer.module').classList.remove('lex-d-none');
      setTimeout(() => window.scrollTo(0, this.currentDeckScrollPosition), 0);
    }
  }

  openDatesAndRates() {
    toggleModalClassListWithoutTouchMove();
    if (this.state.DatesAndRatesOpen == false) {
      this.setActiveDatesAndRates(true);
    } else {
      this.setActiveDatesAndRates(false);
    }
  }

  resetDeckCategory(deck: DeckItem | null) {
    if (!deck) {
      this.setCurrentDeckCategory(null);
    } else {
      const cat = deck.Categories[0];
      this.setCurrentDeckCategory(cat ? cat : null);
    }
  }

  mounted() {
    const decks = this.state.Decks;
    decks.forEach((d: any) => {
      this.getSvgData({ Deck: d, ShipName: this.p.ShipName } as SvgApiData);
    });
  }
}
